import styled from "styled-components";

import { BRAND, BRAND_DARK, GRAY, WHITE } from "../../colors";
import { LARGE_SCREEN } from "../../constants/screenSizes";
import { Caps } from "../../typography";
import buttonThemes from "../constants/buttonThemes";
import calloutCardThemes from "../constants/calloutCardThemes";

export const PseudoButton = styled.span`
  background: ${({ buttonTheme }) =>
    buttonTheme === buttonThemes.PRIMARY_BUTTON ? BRAND : WHITE};
  border: 1px solid
    ${({ buttonTheme }) =>
      buttonTheme === buttonThemes.PRIMARY_BUTTON ? "transparent" : GRAY};
  display: inline-block;
  padding: 0 23px;
  text-align: center;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    width: 100%;
  }
`;

export const PseudoButtonCopy = styled(Caps).attrs({ as: "span" })`
  color: ${({ buttonTheme }) =>
    buttonTheme === buttonThemes.PRIMARY_BUTTON ? WHITE : BRAND};
  line-height: 30px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    line-height: 38px;
  }
`;

export const PseudoLink = styled(Caps).attrs({ as: "span" })`
  color: ${({ theme }) =>
    theme === calloutCardThemes.WHITE ? BRAND : BRAND_DARK};
  display: inline-block;
  margin-top: 10px;
`;
